import { buildBracket } from './bracketUtils';
import { assignGroups, suggestGroupCount } from './groupingUtils';
import { getGroupLabel } from './groupLabels';

/**
 * Regional Bracket (the March Madness format): participants split into N
 * named regions, each an independent single-elimination bracket. Region
 * WINNERS then converge into one Final Stage bracket — the mirror image of
 * Compass Draw, where losers instead DIVERGE into feeder brackets. Reuses
 * buildBracket for every stage; the only new logic here is stitching the
 * region champions together as the Final Stage's seed list.
 */
export const generateRegionalBracket = (participants, options = {}) => {
  const n = participants.length;
  if (n < 4) {
    throw new Error('Regional Bracket needs at least 4 participants');
  }

  const regionCount = Math.max(2, Math.min(options.groupCount || suggestGroupCount(n), Math.floor(n / 2)));
  // An explicit, possibly hand-edited assignment from the group assignment
  // editor takes priority over the automatic serpentine split.
  const regionParticipants = options.groupAssignments || assignGroups(participants, regionCount);

  const regions = regionParticipants.map((participantsInRegion, idx) => {
    const label = getGroupLabel('regional_bracket', idx, options.groupNames);
    const bracket = buildBracket(participantsInRegion, label);
    return { label, ...bracket };
  });

  const champions = regions.map((region) => ({
    id: `champion-${region.label}`,
    name: `Winner of ${region.label}`,
    isPlaceholder: true,
  }));

  const finalStage = buildBracket(champions, 'final-stage');

  return {
    formatId: 'regional_bracket',
    participantsCount: n,
    regionCount,
    regions,
    finalStage: finalStage.rounds,
    finalStageBracketSize: finalStage.bracketSize,
  };
};
